function formatGPXBalance(value) {
  return Number(value).toLocaleString("pt-br", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}
function formatCoin(value, digits) {
  return Number(value).toFixed(digits);
}

function maxDecimals(string, decimals) {
  string = string + "";
  if (string.indexOf(".") === -1 || string.slice(-1) === ".") return string;
  let split = string.split(".");
  let left = split[0];
  let right = split[1];
  if (decimals === 0 || right.length === 0) {
    return parseFloat(left) + "";
  } else {
    return (
      parseFloat(left) +
      "." +
      right.slice(0, Math.min(decimals, right.length)) +
      ""
    );
  }
}
export { formatGPXBalance, formatCoin, maxDecimals };
